import { useMemo } from "react";
import { useSelector } from "react-redux";
import { TableNames } from "../../../../enums/tableNames";
import { RootState } from "../../../../redux/store/store";

/**
 * Returns the filter values scoped to the All Open Orders table.
 *
 * @returns Filter values whose `name` matches the All Open Orders table
 */
export const useValidFilters = () => {
  const { filters } = useSelector((state: RootState) => state.filterValues);

  const validFilters = useMemo(() => {
    return filters.filter(
      (filter) => filter.name === TableNames.ALL_OPEN_ORDERS,
    );
  }, [filters]);

  return validFilters;
};
